import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42f970bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-text-father" }
const _hoisted_2 = { class: "cart-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"8px"} }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Meu carrinho", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"12px"} }, null, -1 /* HOISTED */))
const _hoisted_6 = { class: "amount" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"4px"} }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "total-products-price" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"22px"} }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "cart-button",
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => ($setup.isMouseOver = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => ($setup.isMouseOver = false)),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('open-cart-modal')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode($setup["FontAwesomeIcon"], {
          icon: $setup.Icons.imported.faCartShopping,
          class: "icon"
        }, null, 8 /* PROPS */, ["icon"]),
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, _toDisplayString($setup.cartStore.getItemsAmount()), 1 /* TEXT */)
      ]),
      _hoisted_7,
      _createElementVNode("p", _hoisted_8, "R$ " + _toDisplayString($setup.FormatUtils.formatPrice($setup.cartStore.getTotalItemsPrice())), 1 /* TEXT */)
    ]),
    _hoisted_9,
    _createVNode($setup["FontAwesomeIcon"], {
      icon: $setup.Icons.imported.faChevronRight,
      class: _normalizeClass(`icon ${$setup.isMouseOver ? 'moving' : ''}`)
    }, null, 8 /* PROPS */, ["icon", "class"])
  ], 32 /* NEED_HYDRATION */))
}